import { ajaxController } from "./controller/AjaxController";

class ProductionAjax {
  private _ajaxController = ajaxController;
  private _productionDataEndpoint = "/Production";

  async getAllowedNonWasteLocationTypeIds() {
    return this._ajaxController.get<number[]>(
      `${this._productionDataEndpoint}/location-types/non-waste`,
      {}
    );
  }

  async getAllowedWasteLocationTypeIds() {
    return this._ajaxController.get<number[]>(
      `${this._productionDataEndpoint}/location-types/waste`,
      {}
    );
  }
}

export const productionAjax = new ProductionAjax();